<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="详情 订单信息"
      id-key="OrderId"
      :data="data"
      :save-func="()=>{}"
      form-label-width="110px"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <el-divider>订单内容</el-divider>
        <el-row>
          <el-col :span="8">
            <el-form-item label="订单编号">
              <span>{{data.OrderNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单时间">
              <span>{{this.$commonJs.toDateString(data.AddTime)}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单状态">
              <span>{{data.StatusText}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发货状态">
              <span>{{data.SendStatusText}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款状态">
              <span>{{data.PayStatusText}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退款状态">
              <span>{{data.RefundStatusText}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="联系人">
              <span>{{data.Person}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <span>{{data.Phone}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="配送方式">
              <span>{{data.FreightMode}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="收货地址">
              <span>{{data.Address}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="商品金额">
              <span>{{data.GoodsAmount}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="配送金额">
              <span>{{data.Freight}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="小计金额">
              <span>{{data.SubTotal}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="优惠券">
              <span v-if="data.CouponName">{{data.CouponName}}</span>
              <span v-else>无</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠金额">
              <span>{{data.CouponAmount}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单总额">
              <span>{{data.Amount}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>商品信息</el-divider>
        <el-table border :data="OrderGoods" style="width: 100%" size="mini">
          <el-table-column prop="GoodsName" label="商品名称" min-width="200px" />
          <el-table-column prop="Price" label="单价" min-width="110px" />
          <el-table-column prop="UnitName" label="单位" min-width="120px" />
          <el-table-column prop="Quantity" label="数量" min-width="100px" />
          <el-table-column prop="Amount" label="金额" min-width="120px" />
          <el-table-column prop="Remark" label="备注" min-width="200px" />
          <el-table-column prop="RetailPrice" label="活动" min-width="200px" />
        </el-table>
        <template v-if="data.SendStatus!=0">
          <el-divider>发货信息</el-divider>
          <el-table border :data="DeliverList" style="width: 100%" size="mini">
            <el-table-column prop="ExpressName" label="配送公司" min-width="200px" />
            <el-table-column prop="ExpressNo" label="配送单号" min-width="120px" />
            <el-table-column prop="AddTime" label="发货时间" min-width="150px" />
            <el-table-column prop="ActualFreight" label="实际配送金额" min-width="100px" />
          </el-table>
        </template>
        <template v-if="data.RefundStatus!=0">
          <el-divider>退款信息</el-divider>
          <el-row>
            <el-col :span="12">
              <el-form-item label="申请时间">
                <span>{{this.$commonJs.toDateString(data.ApplyTime)}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="data.RefundStatus>0">
              <el-form-item label="退款金额">
                <span>{{data.RefundAmount}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="退款原因">
                <span>{{data.Reason}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="商家反馈">
                <span>{{data.Feedback}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="商家备注">
                <span>{{data.Remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="data.RefundStatus==3">
            <el-col :span="8">
              <el-form-item label="退货配送公司">
                <span>{{data.BackExpressName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退货配送单号">
                <span>{{data.BackExpressNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退货时间">
                <span>{{this.$commonJs.toDateString(data.BackTime)}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="data.RefundStatus>0">
          <el-divider>退货商品</el-divider>
          <el-table border :data="RefundList" style="width: 100%" size="mini">
            <el-table-column prop="GoodsName" label="商品名称" min-width="200px" />
            <el-table-column prop="Quantity" label="退货数量" />
            <el-table-column prop="Amount" label="退货金额" />
          </el-table>
        </template>
        <el-divider>操作日志</el-divider>
        <el-table border :data="OrderLog" style="width: 100%" size="mini">
          <el-table-column prop="Operator" label="操作者" min-width="70px" />
          <el-table-column prop="AddTime" label="操作时间" min-width="150px" />
          <el-table-column prop="Action" label="动作" min-width="150px" />
          <el-table-column prop="Status" label="订单状态" min-width="100px" />
          <el-table-column prop="SendStatus" label="发货状态" min-width="100px" />
          <el-table-column prop="PayStatus" label="付款状态" min-width="100px" />
          <el-table-column prop="Remark" label="操作备注" min-width="200px" show-overflow-tooltip />
        </el-table>
      </template>
      <template slot="footer">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [detailsDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        OrderId: 0,
        OrderNo: "", //订单编号
        CustomerId: null, //客户编号
        CustomerName: "", //客户名称
        Mobile: "", //手机号
        CustomerType: null, //客户类型 - 1:零售
        GoodsAmount: null, //商品金额
        Quantity: null, //商品数量
        Amount: null, //订单金额
        PayAmount: null, //实付金额
        Point: null, //积分
        AddTime: null, //订单时间
        Status: null, //订单状态 - 0:未确认 1:正常执行中 2:退款中 3:已完成 4:已取消
        StatusText: "",
        SendStatus: null, //发货状态 - 0:未发货 1:已发货 2:已收货 3:退货中 4:退货待收 5:已退货
        SendStatusText: "",
        PayStatus: null, //付款状态 - 0:未付款 1:已付款 2:退款中 3:已退款
        PayStatusText: "",
        RefundAmount: 0, //退款金额
        RefundStatus: null, //退款状态 - 0:无 1:退款待审 2:客户取消 3:同意退款 4:拒绝退款
        RefundStatusText: "",
        FreightMode: null, //配送方式 - 0:异地配送 1:本地配送 2:自提
        ExpressName: "", //配送公司
        ExpressNo: "", //配送单号
        Freight: null, //配送金额
        SubTotal: null, //小计金额
        CouponName: "", //优惠券名称
        CouponAmount: null, //优惠金额
        Person: "", //收货联系人
        Phone: "", //收货联系电话
        Address: "", //收货地址
        Reason: "", //退款原因
        ApplyTime: null, //退款申请时间
        Feedback: "", //商家反馈
        Remark: "", //商家备注
        BackExpressName: "", //退货配送公司
        BackExpressNo: "", //退货配送单号
        BackTime: null, //退货时间
      },
      OrderGoods: [], //商品信息
      OrderLog: [], //操作日志
      DeliverList: [], //发货信息
      RefundList: [], //退货商品
      api: require("@/api/mall/order").default,
      ogApi: require("@/api/mall/orderGoods").default,
      olApi: require("@/api/mall/orderLog").default,
      rgApi: require("@/api/mall/returnGoods").default,
    };
  },
  computed: {},
  methods: {
    onDetailsOpened(data) {
      var params = { OrderId: this.data.OrderId };
      this.ogApi.list(params).then((res) => {
        if (res.Data) this.OrderGoods = res.Data;
      });
      this.olApi.list(params).then((res) => {
        if (res.Data) this.OrderLog = res.Data;
      });
      this.api.getDeliverDocList(this.data.OrderId).then((res) => {
        if (res.Data) this.DeliverList = res.Data;
      });
      if (data.RefundStatus > 0) {
        this.rgApi.list(params).then((res) => {
          if (res.Data) this.RefundList = res.Data;
        });
      }
    },
    onClosed() {
      this.OrderGoods = [];
      this.OrderLog = [];
      this.DeliverList = [];
      this.RefundList = [];
    },
  },
};
</script>